'use client';

// import { useWebSocket } from '@/hooks/useWebSocket';
import { EVENTS } from './events';
import { useAuthenticated, useReady, useUserStoreActions } from '@/store';
import { Wallet } from '@/backend/user/get-user/types';
import { getAccessToken } from '@privy-io/react-auth';
import { useEffect, useState, useCallback } from 'react';

const WebsocketConnections = () => {
	const ready = useReady();
	const authenticated = useAuthenticated();
	const [authToken, setAuthToken] = useState<string | null>(null);
	const [tokenFetched, setTokenFetched] = useState(false);

	useEffect(() => {
		// Only run this once when authentication is ready
		if (ready && authenticated && !tokenFetched) {
			const fetchAccessToken = async () => {
				try {
					const token = await getAccessToken();
					if (token) {
						setAuthToken(token);
					} else {
						console.error('Failed to fetch access token');
					}
					// Mark as fetched regardless of result to prevent additional attempts
					setTokenFetched(true);
				} catch (error) {
					console.error('Error fetching access token:', error);
					setTokenFetched(true); // Also mark as fetched on error
				}
			};

			fetchAccessToken();
		}
	}, [ready, authenticated, tokenFetched]);

	if (!authToken) return null;

	return <WebSocketConnectionsWithLoggedInUser authToken={authToken} />;
};

const WebSocketConnectionsWithLoggedInUser = ({
	authToken,
}: {
	authToken: string;
}) => {
	//   const { updateWallet } = useUserStoreActions();
	//   const config = {
	//     SOCKET_URL: 'https://api.dev.otherworld.xyz',
	//   };

	//   // Define handler function with useCallback to prevent recreating on every render
	//   const handleWalletUpdate = useCallback((data: Wallet) => {
	//     updateWallet(data);
	//   }, [updateWallet]);

	//   // Use the fixed hook
	//   const { isConnected, error } = useWebSocket(
	//     config.SOCKET_URL,
	//     "wallet",
	//     handleWalletUpdate,
	//     authToken
	//   );

	//   // Optional logging
	//   useEffect(() => {
	//     if (isConnected) {

	//     }
	//     if (error) {

	//     }
	//   }, [isConnected, error]);

	return null;
};

export default WebsocketConnections;

// 	// [EVENTS.BET]: (data) => r'Bet placed:', data),
// [EVENTS.EXCHANGE_BET]: (data) => console.log('Exchange Bet:', data),
// [EVENTS.LOGOUT]: (data) => console.log('User logged out:', data),
// [EVENTS.DEPOSIT]: (data) => console.log('Deposit event:', data),
// [EVENTS.EXCHANGE_RATE]: (data) =>
// 	console.log('Exchange rate update:', data),
// [EVENTS.VIP_LEVEL]: (data) => console.log('VIP level update:', data),
// [EVENTS.BET_LIMIT]: (data) => console.log('Bet limit update:', data),
// [EVENTS.RELOAD_HISTORY]: (data) =>
// 	console.log('Reload history event:', data),
// [EVENTS.WITHDRAW]: (data) => console.log('Withdrawal event:', data),
// });
